export default __webpack_public_path__ + "static/media/icon_catalogue.083e1183.svg";